import {observer} from "mobx-react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../react-hooks/use-services.hook";
import {JackpotBetsToggle} from "../../jackpot-bets/toggle/jackpot-bets-toggle";

export const JackpotBetDialogShowcase: React.FC = observer(() => {
    const services = useServices();
    return (
        <div style={{flexBasis: "100%"}}>
            <Button
                preset="primary"
                onClick={() => { services.jackpotBet.requestOptInDialog();}}
                margin={"0px 0px 24px 0px"}
            >
                SHOW JACKPOTBET!
            </Button>
            <JackpotBetsToggle />
        </div>)
})

